import { FC, ReactNode, useCallback } from 'react';
import { Text } from 'src/redesign/components/Text';
import S from './SimpleConnectionModal.module.scss';
import { RedesignButton } from 'src/redesign/components/RedesignButton';
import { launchPopup } from 'src/redesign/pages/IntegrationsPage/utils/launchPopup';
import { API_URL } from 'src/utils/transport';

type Props = {
  url?: string;
  name: string;
  icon?: ReactNode;
  information?: ReactNode;
};

export const SimpleConnectionModal: FC<Props> = ({ url, icon, information }) => {
  const handleOnClick = useCallback(() => {
    url && launchPopup(`${API_URL}${url}`);
  }, [url]);

  return (
    <div className={S.simpleConnectionModal}>
      <div className={S.content}>
        <div className={S.iconWrapper}>{icon}</div>
        <Text variation="body" thin>
          {information}
        </Text>
      </div>

      <RedesignButton variation="primary" onClick={handleOnClick} className={S.button} height={44}>
        <Text variation="body" color="white-100">
          Connect
        </Text>
      </RedesignButton>
    </div>
  );
};
